import { Box, CircularProgress, Typography } from "@mui/material";
import { useValidateProductSession } from "./api/hooks";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { allowedOrigins } from "../../common/auth/allowed-origins";
import { mainCont } from "./sxprops";

const ValidateProductSession: React.FC = () => {
  const validateProductSession = useValidateProductSession();
  const params = new URLSearchParams(window.location.search);
  const callback = params.get("callback");
  const navigate = useNavigate();

  const isValidCallback = (() => {
    try {
      const url = new URL(callback ?? "");
      return allowedOrigins.includes(url.origin);
    } catch {
      return false;
    }
  })();

  useEffect(() => {
    if (
      (validateProductSession.status === "success" ||
        validateProductSession.status === "error") &&
      callback
    ) {
      if (!isValidCallback) {
        console.error("Blocked invalid callback URL:", callback);
        return;
      }
      const redirectUrl = new URL(callback);
      if (validateProductSession.status === "success") {
        redirectUrl.searchParams.set("c0A1", validateProductSession.data.c0A1);
        redirectUrl.searchParams.set("c0B2", validateProductSession.data.c0B2);
      } else if (validateProductSession.status === "error") {
        redirectUrl.searchParams.set("status", "412");
      }

      window.location.href = redirectUrl.toString();
    }
  }, [
    callback,
    isValidCallback,
    navigate,
    validateProductSession.data?.c0A1,
    validateProductSession.data?.c0B2,
    validateProductSession.status,
  ]);

  return (
    <Box sx={mainCont}>
      <CircularProgress
        sx={{
          color: "text.secondary",
        }}
      />

      <Typography color="text.secondary">
        {validateProductSession.status === "pending"
          ? "Validating product session"
          : validateProductSession.status === "success"
          ? "Session validated!"
          : "Session not valid!"}
      </Typography>
    </Box>
  );
};

export default ValidateProductSession;
